import { render } from "./Canvas.vue?vue&type=template&id=72c5a580"
import script from "./Canvas.vue?vue&type=script&lang=js"
export * from "./Canvas.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alexmeister/Documents/GitHub/barq2_0_new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__